import { ILocation, ILocationFormValues, ILocationFilter, ILocationTable } from "../pages/Location/types/";
import api from "./api";
import { CancelToken } from "axios";

export default class LocationService {
    async getLocations({ limit, offset, searchTerm }: ILocationFilter, cancelToken?: CancelToken): Promise<ILocationTable> {
        const params = new URLSearchParams();
        if (limit) params.append('limit', limit.toString());
        if (offset) params.append('offset', offset.toString());
        if (searchTerm) params.append('searchTerm', searchTerm);

        const result = await api.get(`/v1/location/with-stations?${params.toString()}`, { cancelToken });
        return result.data;
    }

    async getAllLocations(): Promise<ILocation[]> {
        const result = await api.get(`/v1/location`);
        return result.data;
    }

    async getLocation(id: number): Promise<ILocation> {
        const result = await api.get(`/v1/location/${id}`);
        return result.data;
    }

    async createLocation(locationData: ILocationFormValues): Promise<ILocation> {
        const result = await api.post(`/v1/location`, {
            name: locationData.name,
            coordinatesType: locationData.coordinatesType,
            coordinates: locationData.coordinates,
            locationId: locationData.locationId,
        });

        if (result.status === 200 || result.status === 201) {
            return result.data;
        }
        throw new Error("Error while creating new location");
    }

    async updateLocation(
        id: number,
        locationData: ILocationFormValues
    ): Promise<{ success: boolean }> {
        if (!id) {
            throw new Error("Need to inform ID for update data");
        }

        const result = await api.put(`/v1/location/${id}`, {
            name: locationData.name,
            coordinatesType: locationData.coordinatesType,
            coordinates: locationData.coordinates,
            locationId: locationData.locationId,
        });

        if (result.status === 200 || result.status === 201) {
            return result.data;
        }
        throw new Error("Error while updating location");
    }

    async deleteLocation(id: number): Promise<boolean> {
        if (!id) {
            throw new Error("Need to inform ID for delete data");
        }

        const result = await api.delete(`/v1/location/${id}`);

        if (result.status === 200 || result.status === 204) {
            return true;
        }
        throw new Error("Error while deleting location");
    }
}